module.exports = __webpack_public_path__ + "img/phone.fdd3c80e.svg";